"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var date_fns_1 = require("date-fns");

var TimeBaseComponent_1 = require("./TimeBaseComponent");

var TimeDistance =
/** @class */
function (_super) {
  __extends(TimeDistance, _super);

  function TimeDistance() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  TimeDistance.prototype.render = function () {
    if (!this.props.children) {
      return null;
    }

    var locale = this.state.locale;

    var _a = this.props.children.split(':').map(function (x) {
      return Number(x);
    }),
        hours = _a[0],
        minutes = _a[1],
        seconds = _a[2];

    var now = new Date();
    var timeSeconds = date_fns_1.addSeconds(now, seconds);
    var timeMinutes = date_fns_1.addMinutes(now, minutes);
    var timeHours = date_fns_1.addHours(now, hours);
    var text = [hours && date_fns_1.formatDistanceStrict(now, timeHours, {
      locale: locale,
      unit: 'hour'
    }), hours && minutes && seconds && ', ', hours && minutes && !seconds && ' and ', minutes && date_fns_1.formatDistanceStrict(now, timeMinutes, {
      locale: locale,
      unit: 'minute'
    }), minutes && seconds && ' and ', seconds && date_fns_1.formatDistanceStrict(now, timeSeconds, {
      locale: locale,
      unit: 'second'
    })].filter(function (x) {
      return !!x;
    }).join('');
    return React.createElement(React.Fragment, null, text);
  };

  return TimeDistance;
}(TimeBaseComponent_1.TimeBaseComponent);

exports.TimeDistance = TimeDistance;